import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";
import RatchetLogo from "@/components/RatchetLogo";

export default function MarketingFooter() {
  const t = useT();
  return (
    <footer className="border-t border-white/5 mt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <RatchetLogo size={28} />
            <span className="font-display font-black tracking-tight">RATCHET</span>
          </div>
          <p className="text-sm text-white/50 max-w-xs leading-relaxed">{t("footer.tagline")}</p>
          <div className="overline mt-6">v1.0 · 2026</div>
        </div>
        <div>
          <div className="overline mb-3">{t("footer.product")}</div>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/pricing" className="hover:text-white">{t("nav.pricing")}</Link></li>
            <li><Link to="/demo" className="hover:text-white">{t("nav.demo")}</Link></li>
            <li><Link to="/signup" className="hover:text-white">{t("auth.startFree")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">{t("footer.resources")}</div>
          <ul className="space-y-2 text-sm text-white/60">
            <li>Azure DevOps</li>
            <li>GitHub · GitLab</li>
            <li>Jira · Linear</li>
            <li>AWS · Datadog · Splunk</li>
            <li>PostgreSQL · MongoDB</li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">{t("footer.company")}</div>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/about" className="hover:text-white">{t("footer.about")}</Link></li>
            <li><Link to="/partners" className="hover:text-white">{t("nav.partners")}</Link></li>
            <li><a href="mailto:owners@myratchet.com" className="hover:text-white">{t("footer.contact")}</a></li>
            <li><Link to="/terms" className="hover:text-white">{t("footer.terms")}</Link></li>
            <li>{t("footer.status")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-white/40 font-mono">
          <div>{t("footer.rights")}</div>
          <div>{t("footer.builtFor")}</div>
        </div>
      </div>
    </footer>
  );
}
